import React, { useEffect, useMemo, useRef, useState } from 'react';

const WINNER_SOUND = '/assets/whoispaying/Winner%20confirm.mp3';

export default function WinnerPopup({ open, winners = [], award = '', score = null, onClose }) {
  const audioRef = useRef(null);
  const [closing, setClosing] = useState(false);

  const winnerText = useMemo(() => {
    if (!Array.isArray(winners) || winners.length === 0) return '';
    const names = winners.map((w) => w?.name).filter(Boolean);
    if (names.length === 1) return names[0];
    if (names.length === 2) return names.join(' and ');
    return names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1];
  }, [winners]);

  useEffect(() => {
    if (!open) return;
    const el = audioRef.current;
    if (!el) return;
    try {
      el.volume = 0.7; // 30% less than full volume
      el.currentTime = 0;
      el.play();
    } catch {}
  }, [open]);

  // Auto-dismiss after 5s with a gentle fade
  useEffect(() => {
    if (!open) return;
    const t1 = setTimeout(() => setClosing(true), 10000);
    const t2 = setTimeout(() => { if (closing) onClose && onClose(); }, 10400);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [open, closing, onClose]);

  if (!open) return null;

  const winnerScore = typeof score === 'number' ? score : null;

  return (
    <div
      className={`winner-modal-overlay${closing ? ' is-closing' : ''}`}
      role="dialog"
      aria-modal="true"
      aria-label="Winners"
    >
      <div className="winner-modal" onClick={(e) => e.stopPropagation()}>
        <div className="winner-medal">
          <div className="winner-medal-inner" aria-hidden="true">
            🏆
          </div>
        </div>
        <div className="winner-meta">
          <div className="winner-label">Winner decided</div>
          <div className="winner-name">{winnerText || 'Winner'}</div>
          {winnerScore != null && (
            <div className="winner-score">
              {winnerScore}
            </div>
          )}
          <div className="winner-award">
            {award ? `will ${award}` : 'will take the prize!'}
          </div>
          <div className="winner-subtext">
            It’s decided; check the results below.
          </div>
        </div>
        <audio ref={audioRef} src={WINNER_SOUND} preload="auto" />
      </div>
    </div>
  );
}
